import { SxProps, Theme } from '@mui/material';

export const containerCouponBarSX: SxProps<Theme> = {
	backgroundColor: 'primary.main',
	color: 'primary.contrastText',
	textAlign: 'center',
	padding: '8px 16px',
	fontSize: {
		xs: 'var(--font-size-small)',
		sm: 'var(--font-size-default)',
	},
	lineHeight: 1.4,
};

export const discountCouponBarSX: SxProps<Theme> = {
	font: 'inherit',
	fontWeight: 700,
};

export const linkCouponBarSX: SxProps<Theme> = {
	color: 'inherit',
	fontWeight: 700,
	textDecoration: 'underline',
	whiteSpace: 'nowrap',
	'&:hover': {
		color: 'inherit',
		opacity: 0.85,
	},
};
